import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=87c5edee&scoped=true&"
import script from "./Tip.vue?vue&type=script&lang=js&"
export * from "./Tip.vue?vue&type=script&lang=js&"
import style0 from "./Tip.vue?vue&type=style&index=0&id=87c5edee&prod&scoped=true&lang=css&"
import style1 from "./Tip.vue?vue&type=style&index=1&id=87c5edee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c5edee",
  null
  
)

export default component.exports